<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>
    <div class="title">请选择清洁类型</div>
    <br>
    <div class="main">
      <div class="btn-long no-margin-top" @click="orderUpdate('type_id','1550735960','/cleanex-start')">
        <div class="col1">
          <img class="promo-image" src='../../assets/img/clean/icon/tf.svg'>
        </div>
        <div class="col2">
          <div class="col2-row1">退房清洁</div>
          <div class="col2-row2">租期到期，房屋退还给中介、房东</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">最近{{orderStats['1550735960']}}人下单</div>
      </div>

      <div class="btn-long" @click="orderUpdate('type_id','1550735948','/cleanex-start')">
        <div class="col1">
          <img class="promo-image" src='../../assets/img/clean/icon/dsc.svg'>
        </div>
        <div class="col2">
          <div class="col2-row1">大扫除清洁</div>
          <div class="col2-row2">房屋很久没有打扫，想做一次性专业清洁</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">最近{{orderStats['1550735948']}}人下单</div>
      </div>


      <div class="btn-long" @click="orderUpdate('type_id','1550735962','/cleanex-start')">
        <div class="col1">
          <img class="promo-image" src='../../assets/img/clean/icon/zx.svg'>
        </div>
        <div class="col2">
          <div class="col2-row1">专项清洁</div>
          <div class="col2-row2">只想清洁某一项或几项，例如洗地毯</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">最近{{orderStats['1550735962']}}人下单</div>
      </div>

      <div class="btn-long" @click="orderUpdate('type_id','1550735971','/cleanex-start')">
        <div class="col1">
          <img class="promo-image" src='../../assets/img/clean/icon/zqx.svg'>
        </div>
        <div class="col2">
          <div class="col2-row1">周期性清洁</div>
          <div class="col2-row2">想固定时间清洁，例如2周一次等</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
        <div class="badge" v-show="Object.keys(orderStats).length>0">最近{{orderStats['1550735971']}}人下单</div>
      </div>

      <div class="btn-long" @click="orderUpdate('type_id','1550735961','/cleanex-start')">
        <div class="col1">
          <img class="promo-image" src='../../assets/img/clean/icon/airbnb.svg'>
        </div>
        <div class="col2">
          <div class="col2-row1">Airbnb清洁</div>
          <div class="col2-row2">适合 Airbnb 的房东或中介</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
      </div>

       <div class="btn-long" @click="goto('/contact-clean')">
        <div class="col1">
          <img class="promo-image" src='../../assets/img/clean/icon/sy.svg'>
        </div>
        <div class="col2">
          <div class="col2-row1">商业清洁</div>
          <div class="col2-row2">商铺整体、厨房、排油排风系统</div>
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>

      </div>

    </div>
    <div class="js_dialog" v-show="isLeaving">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">订单尚未完成</strong></div>
            <div class="weui-dialog__bd">确定要回到首页吗？回去后将丢失当前下单进度</div>
            <div class="weui-dialog__ft">
                <div  class="weui-dialog__btn weui-dialog__btn_default" @click="isLeaving=false">取消</div>
                <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="goto('/')">回到首页</div>
            </div>
        </div>
    </div>
    <img :src="pixelURL('cangchu','step2')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      order:{
        service:'cleanEx',
        orderStats:{},
        data:{
          token:0,
          type_id:"",
          address_name:"",
          address_phone:"",
          address_street:"",
          address_suburb:"",
          address_postcode:"",
          address_unit:"",
          address_state:"NSW",
          service_date:"",
          service_period:"",
          house_type:"",
          house_layout:"",
          is_carpet:3,
          carpet:1,
          parking:"",
          msg:"",
          msgAttach:"",
          floor:"",
          is_duplex:"3",
          duplex_floor:2,
          order_source:"3",
          coupon_id:"",
          couponLocked:"",
          couponValue:0,
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:''
        }
      },
      isLeaving:false,
    }
  },
  methods: {
    goback(){
      this.isLeaving = true;
    }
  },
  created: function () {
    if (localStorage.orderStats) {
      this.orderStats = JSON.parse(localStorage.orderStats);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-long{
  position:relative;
  width: 85%;
  height: 80px;
  cursor: pointer;
  display: flex;
  justify-content:space-around;
  align-items: center;
  border-radius: 5px;
  font-size: 1.1em;
  margin: 0 auto;
  margin-top: 20px;
  padding-left:2vw;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
  background: #fff;
    -webkit-box-shadow:0 0 20px rgba(0,0,0,0.8);
    -moz-box-shadow:0 0 20px rgba(0,0,0,0.8);
    box-shadow:0 0 10px rgba(0,0,0,0.2);
  -webkit-box-shadow: 0px 3px 15px 0px rgba(228,232,241,1); 
  box-shadow: 0px 3px 15px 0px rgba(228,232,241,1);
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}

.badge{
  position:absolute;
  top:-6px;
  right:0;
  box-sizing:border-box;
  background:$color-orange;
  background-image: linear-gradient(90deg, #fb6835 0%, #fe7444 100%);
  padding:3px 12px;
  font-size:12px;
  color:#fff;
  -webkit-border-radius: 10px;
  -webkit-border-top-left-radius: 0;
  -webkit-border-bottom-right-radius: 0;
  -moz-border-radius: 10px;
  -moz-border-radius-topleft: 0;
  -moz-border-radius-bottomright: 0;
  border-radius: 10px;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
}

.no-margin-top{
  margin-top:0;
}

.promo-image{
  width:80%;
  margin:6px auto;
  display:block;
  
}

.col1{
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}

.col1-row1{
  color:#555;
  line-height:1;
  font-size:1.1em;
}
.col1-row2{
  border:1px solid #ff7444;
  border-radius:3px;
  font-size:0.7em;
  font-weight:200;
  color:#000;
  padding:0px 5px;
  display:inline-block;
}

.col2{
    -webkit-box-flex: 7;
    -webkit-flex: 7;
    flex: 7;
    padding-left:2vw;
}

.col2-row1{
  text-align:left;
  font-size:1em;
  color:#5A5D67;
}

.col2-row2{
  color:#999;
  font-size:0.65em;
  text-align:left;
  margin-top:2px;
  margin-bottom:2px;
}

.col2-row3{
  color:#999;
  font-size:0.7em;
  text-align:right;
  margin-top:2px;
  margin-bottom:2px;
  font-weight:200;
}

.col-3{
  font-size:2em;
  color:#ccc;
}

</style>



// WEBPACK FOOTER //
// src/pages/cleanEx/clean-guide.vue